export default {"src":"/_next/static/media/back-chevron-icon.dba37dae.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};